<script>
	import { onMount } from 'svelte';
	import Loader from './Loader.svelte';

	onMount(() => {
		const parllax = document.querySelector('.parallax');

		window.addEventListener("scroll", function() {
			if (window.innerWidth <= 736) {
				parllax.style.backgroundPositionY = '0px';
				return;
			}
			let offset = window.pageYOffset;
			parllax.style.backgroundPositionY = offset * -0.5 + 'px';
		});

		const loader = document.querySelector('.loader');
		const title = document.querySelector('.title');
		setTimeout(() => {
			loader.style.display = 'none';
			title.className += ' fadeInLeft animated';
		}, 1400);
	});
</script>

<Loader />
<div class="parallax">
	<div class="headline">
		<h1 class="title">Thea Kitzinger</h1>
	</div>
</div>

<div class="content">
	<h1>Frontend Developer</h1>
	<p>
		HTML, CSS, SASS, JS, Node.Js, AngularJS, React, Django, Python
	</p>
	<p>
		Opened to any new technology :)
	</p>
	<div class="connect">
		<a href="mailto:thealein1991@gmail.com">
			<img src="icons/email.svg" width="50px" alt="My Email">
		</a>
		<a href="https://www.linkedin.com/in/thea-kitzinger-621782b9/" target="blank">
			<img src="icons/linkedin.svg" width="50px" alt="Linkedin">
		</a>
		<a href="https://www.facebook.com/thea.kitzinger" target="_blank">
			<img src="icons/facebook.svg" width="50px" alt="Facebook">
		</a>
		<a href="https://www.instagram.com/thealein1991/" target="_blank">
			<img src="icons/instagram.svg" width="50px" alt="Instagram">
		</a>
		<a href="https://github.com/thki91" target="_blank">
			<img src="icons/github.svg" width="50px" alt="Github">
		</a>
	</div>
</div>
